export const VTO_CAMERA_CLOSED = 'vto.cameraClosed';
export const VTO_CAMERA_FAILED = 'vto.cameraFailed';
export const VTO_CAMERA_OPENED = 'vto.cameraOpened';
export const VTO_COMPARE = 'vto.compare';
export const VTO_COMPARE_DISABLED = 'vto.compareDisabled';
export const VTO_CLOSED = 'vto.closed';
export const VTO_ENGINE_CLOSED = 'vto.engineClosed';
export const VTO_LOADED = 'vto.loaded';
export const VTO_LOADING = 'vto.loading';
export const VTO_KISS_DETECTED = 'vto.kissDetected';
export const VTO_OPENED = 'vto.opened';
export const VTO_PAIR_SHADE_GRID_OPENED = 'vto.pairShadeGridOpened';
export const VTO_PAIR_SHADE_SELECTED = 'vto.pairShadeSelected';
export const VTO_PHOTO_LOADED = 'vto.photoLoaded';
export const VTO_PHOTO_SAVED = 'vto.photoSaved';
export const VTO_RESET = 'vto.reset';
export const VTO_VIDEO_LOADED = 'vto.videoLoaded';
export const VTO_SHADE_FINDER_STARTED = 'vto.shadeFinderStarted';
export const VTO_SHADE_FINDER_COMPLETED = 'vto.shadeFinderCompleted';
export const VTO_SHADE_FINDER_CANCELLED = 'vto.shadeFinderCancelled';
export const VTO_SKIN_SHADE_FOUND = 'vto.skinShadeFound';
export const VTO_ZOOM = 'vto.zoom';
export const VTO_FOUNDATION_OVERLAY_TOGGLED = 'vto.foundation.overlay.toggled';

export const VTO_SKIN_CARE_OPENED = 'vto.skin.care.opened';
export const VTO_SKIN_CARE_CAMERA_OPENED = 'vto.skin.care.cameraOpened';
export const VTO_SKIN_CARE_CAMERA_FAILED = 'vto.skin.care.cameraFailed';
export const VTO_SKIN_CARE_CAMERA_CLOSED = 'vto.skin.care.cameraClosed';
export const VTO_SKIN_CARE_LOADING = 'vto.skin.care.loading';
export const VTO_SKIN_CARE_LOADED = 'vto.skin.care.loaded';
export const VTO_SKIN_CARE_VIDEO_LOADED = 'vto.skin.care.videoLoaded';
export const VTO_SKIN_ANALYSIS_STARTED = 'vto.skin.care.analysisStarted';
export const VTO_SKIN_ANALYSIS_FINISHED = 'vto.skin.care.analysisFinished';
export const VTO_SKIN_BACK_TO_DETECTING = 'vto.skin.care.backToDetecting';
export const VTO_SKIN_CARE_CLOSED = 'vto.skin.care.closed';
export const VTO_SKIN_CARE_RESULT_LOADED = 'vto.skin.care.result.loaded';

export type ServiceVtoEvents = {
    [VTO_CAMERA_CLOSED]: undefined;
    [VTO_CAMERA_FAILED]: undefined;
    [VTO_CAMERA_OPENED]: undefined;
    [VTO_COMPARE]: undefined;
    [VTO_COMPARE_DISABLED]: undefined;
    [VTO_CLOSED]: undefined;
    [VTO_ENGINE_CLOSED]: undefined;
    [VTO_LOADED]: undefined;
    [VTO_LOADING]: undefined;
    [VTO_KISS_DETECTED]: undefined;
    [VTO_OPENED]: undefined;
    [VTO_PAIR_SHADE_GRID_OPENED]: undefined;
    [VTO_PAIR_SHADE_SELECTED]: undefined;
    [VTO_PHOTO_LOADED]: undefined;
    [VTO_PHOTO_SAVED]: undefined;
    [VTO_RESET]: undefined;
    [VTO_VIDEO_LOADED]: undefined;
    [VTO_SHADE_FINDER_STARTED]: undefined;
    [VTO_SHADE_FINDER_COMPLETED]: undefined;
    [VTO_SHADE_FINDER_CANCELLED]: undefined;
    [VTO_SKIN_SHADE_FOUND]: undefined;
    [VTO_ZOOM]: undefined;
    [VTO_FOUNDATION_OVERLAY_TOGGLED]: { isOverlayOpened: boolean };
    [VTO_SKIN_CARE_OPENED]: undefined;
    [VTO_SKIN_CARE_CAMERA_OPENED]: undefined;
    [VTO_SKIN_CARE_CAMERA_FAILED]: undefined;
    [VTO_SKIN_CARE_CAMERA_CLOSED]: undefined;
    [VTO_SKIN_CARE_LOADING]: undefined;
    [VTO_SKIN_CARE_LOADED]: undefined;
    [VTO_SKIN_CARE_VIDEO_LOADED]: undefined;
    [VTO_SKIN_ANALYSIS_STARTED]: undefined;
    [VTO_SKIN_ANALYSIS_FINISHED]: undefined;
    [VTO_SKIN_BACK_TO_DETECTING]: undefined;
    [VTO_SKIN_CARE_CLOSED]: undefined;
    [VTO_SKIN_CARE_CLOSED]: undefined;
    [VTO_SKIN_CARE_RESULT_LOADED]: undefined;
};
